<template>
  <b-modal title="Checagem de Itens" v-model="show" size="xl">
    <b-container fluid>
      <b-row>
        <b-col cols="6">
          <b-form-group label="Descrição:" label-for="descricao" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="descricao" v-model="listaDeChecagem.descricao" />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Período:" label-for="periodo" label-cols-sm="2" label-align-sm="right">
            <b-form-input id="periodo" v-model="listaDeChecagem.periodo" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <!-- :::::::::::::::::::::::::::: TABELA DE MEDIÇÕES :::::::::::::::::::::::::::: -->
        <b-col cols="12">
          <b-table
            id="table-checagem"
            sticky-header
            style="max-height: 400px"
            bordered
            hover
            small
            head-variant="light"
            :items="listaDeChecagem.itens"
            :fields="fields.checkitens"
          >
            <template #cell(item)="data">
              <div>
                <b-form-textarea v-model="data.item.item" :rows="linhas" />
              </div>
            </template>
            <template #cell(conjunto)="data">
              <div>
                <b-form-textarea v-model="data.item.conjunto" :rows="linhas" />
              </div>
            </template>
            <template #cell(descricao)="data">
              <div>
                <b-form-textarea v-model="data.item.descricao" :rows="linhas" />
              </div>
            </template>
            <template #cell(laudo)="data">
              <div>
                <b-form-group>
                  <b-form-radio-group v-model="data.item.laudo" :options="options"></b-form-radio-group>
                </b-form-group>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-container>
    <!-- :::::::::::::::::::::::::::: MODAL DE EDIÇÃO :::::::::::::::::::::::::::: -->
    <template-checklist-modal ref="templateChecklist" @loadTemplate="loadTemplate($event)" />

    <template #modal-footer>
      <b-button variant="primary" @click="adicionar()"> <b-icon icon="plus-circle" aria-hidden="true" /> </b-button>
      <b-button variant="danger" @click="remover()"> <b-icon icon="dash-circle" aria-hidden="true" /> </b-button>
      <b-button variant="info" @click="carregar()">Carregar</b-button>
      <b-button variant="primary" @click="salvar()">Salvar</b-button>
      <b-button variant="info" @click="templates()">Templates</b-button>
      <b-button variant="secondary" @click="show = !show">Fechar</b-button>
    </template>
  </b-modal>
</template>

<script>
import { useSgcqStore } from "@/stores/SgcqStore";
import { useTemplateStore } from "@/stores/TemplateStore";
import Notificacao from "@/models/Notificacao";
import TableFields from "@/tools/TableFields";
import Checklist from "@/models_reports/Checklist";
import ChecklistTemplateModal from "@/components/modals/template/ChecklistTemplateModal";
import ListaDeChecagem from "@/models_reports/ListaDeChecagem";

export default {
  name: "ModalDeChecklistItensCK",

  components: {
    "template-checklist-modal": ChecklistTemplateModal,
  },

  data() {
    return {
      show: false,
      linhas: 5,
      checklist: new Checklist(),
      listaDeChecagem: new ListaDeChecagem(),
      fields: new TableFields(),
      options: [
        { text: "Sim", value: true },
        { text: "Não", value: false },
      ],
    };
  },

  methods: {
    templates() {
      this.$refs.templateChecklist.call();
    },

    carregar() {
      this.checklist.itens = this.listaDeChecagem.itens;
      this.show = !this.show;
    },

    adicionar() {
      this.checklist.itens.push({
        item: "" + (this.checklist.itens.length + 1),
        conjunto: "- - -",
        descricao: "- - -",
        laudo: true,
      });
      this.listaDeChecagem.itens.push({
        item: "" + (this.listaDeChecagem.itens.length + 1),
        conjunto: "- - -",
        descricao: "- - -",
        laudo: true,
      });
    },

    remover() {
      this.checklist.itens.pop();
      this.listaDeChecagem.itens.pop();
    },

    salvar() {
      if (this.listaDeChecagem.id != 0) {
        this.templateStore.ALTERAR_CHECKLIST(this.listaDeChecagem).then(() => {
          for (var i = 0; i < this.listaDeChecagem.itens.length; i++) {
            this.templateStore.ALTERAR_CHECKLIST_ITEM(this.listaDeChecagem.itens[i]);
          }
          this.store.NOTIFICAR(new Notificacao("Checklist salvo no SGCQ com sucesso!", "Excelente!", "success"));
        });
      } else {
        //pode ser implementado no futuro!
      }
    },

    loadTemplate(template) {
      this.listaDeChecagem = template;
      this.checklist.itens = template.itens;
      //this.$emit("loadMedicoes", template.itens);
    },

    call(checklist) {
      this.checklist = checklist;
      this.show = !this.show;
    },
  },

  setup() {
    const store = useSgcqStore();
    const templateStore = useTemplateStore();

    return {
      store,
      templateStore,
    };
  },
};
</script>

<style lang="scss" scoped></style>
